 //  src/pages/agent/TransactionsTablePage.js  
import React, { useEffect, useState } from 'react';
import DashboardLayout from '../../components/Layout/DashboardLayout';
import TransactionsTablePage from '../shared/SharedTransactionsPage';
import { useNavigate } from 'react-router-dom';
import { getUserFromStorage } from '../../utils/auth'; // make sure this function exists

const AgentTransactionsPage = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = getUserFromStorage();
    if (storedUser?.role === 'agent') {
      setUser(storedUser);
    }else {
      navigate('/login'); // ✅ redirect to login if not agent
    }
  }, [navigate]);

  if (!user) {
    return (
      <div style={{ textAlign: 'center', marginTop: '100px' }}>
        <p>Checking session...</p>
      </div>
    );
  }
  

  return (
    <DashboardLayout role="agent">
      <TransactionsTablePage user={user} />
    </DashboardLayout>
  );
};

export default AgentTransactionsPage;
